import $ from 'jquery';
import debounce from 'just-debounce';
import VanillaModal from 'vanilla-modal';

export default class Password {
  constructor() {
    this.$body = $('body');
    this.$modalToggle = $('[data-password-modal-open]');
    this.modalContents = '[data-password-modal]';
    this.$newsletterInput = $('[data-newsletter-input]');

    this.modalOptions = {
      loadClass: 'modal-loaded',
      close : '[data-password-modal-close]',
      onOpen: () => {
        const $modal = $('[data-modal-content]');
        this._centerModal($modal);
        $modal.find('[data-password-input]').focus();

        $(window).on('resize', debounce(() => {
          this._centerModal($modal);
        }, 200));
      },
      onClose: () => { this.$newsletterInput.focus(); },
    };

    this._init();
  }

  _init() {
    if ($('[data-password-has-errors]').length) {
      this._openModal();
    }

    this.$modalToggle.on('click', event => {
      event.preventDefault();
      this._openModal();
    });
  }

  _openModal(){
    new VanillaModal(this.modalOptions).open(this.modalContents);
  }

  _centerModal($modal) {
    const modalHeight = $modal.outerHeight();
    const marginTop = (window.innerHeight - modalHeight) / 2;

    $modal.css({marginTop});
  }
}
